/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetPriceDto } from './GetPriceDto';
import {
    GetPriceDtoFromJSON,
    GetPriceDtoFromJSONTyped,
    GetPriceDtoToJSON,
} from './GetPriceDto';
import type { GetCompanyDto } from './GetCompanyDto';
import {
    GetCompanyDtoFromJSON,
    GetCompanyDtoFromJSONTyped,
    GetCompanyDtoToJSON,
} from './GetCompanyDto';

/**
 * 
 * @export
 * @interface GetPricingDto
 */
export interface GetPricingDto {
    /**
     * 
     * @type {string}
     * @memberof GetPricingDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetPricingDto
     */
    name?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof GetPricingDto
     */
    startDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof GetPricingDto
     */
    endDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof GetPricingDto
     */
    companyId: string;
    /**
     * 
     * @type {GetCompanyDto}
     * @memberof GetPricingDto
     */
    company?: GetCompanyDto | null;
    /**
     * 
     * @type {string}
     * @memberof GetPricingDto
     */
    percentageDiscount?: string | null;
    /**
     * 
     * @type {Array<GetPriceDto>}
     * @memberof GetPricingDto
     */
    prices?: Array<GetPriceDto> | null;
}

/**
 * Check if a given object implements the GetPricingDto interface.
 */
export function instanceOfGetPricingDto(value: object): value is GetPricingDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('startDate' in value) || value['startDate'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    return true;
}

export function GetPricingDtoFromJSON(json: any): GetPricingDto {
    return GetPricingDtoFromJSONTyped(json, false);
}

export function GetPricingDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPricingDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'startDate': (new Date(json['startDate'])),
        'endDate': json['endDate'] == null ? undefined : (new Date(json['endDate'])),
        'companyId': json['companyId'],
        'company': json['company'] == null ? undefined : GetCompanyDtoFromJSON(json['company']),
        'percentageDiscount': json['percentageDiscount'] == null ? undefined : json['percentageDiscount'],
        'prices': json['prices'] == null ? undefined : ((json['prices'] as Array<any>).map(GetPriceDtoFromJSON)),
    };
}

export function GetPricingDtoToJSON(value?: GetPricingDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'startDate': ((value['startDate']).toISOString()),
        'endDate': value['endDate'] == null ? undefined : ((value['endDate'] as any).toISOString()),
        'companyId': value['companyId'],
        'company': GetCompanyDtoToJSON(value['company']),
        'percentageDiscount': value['percentageDiscount'],
        'prices': value['prices'] == null ? undefined : ((value['prices'] as Array<any>).map(GetPriceDtoToJSON)),
    };
}

